export enum ExecutiveStatus {
  INACTIVE = 2,
  ACTIVE = 3,
}
